import { PrivacyControls } from "@/components/legal/CookieConsent";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export function LegalDocumentLinks() {
  const { t } = useTranslation();
  return (
    <nav aria-label={t("footer.legalDocuments")} className="flex flex-wrap gap-x-4 gap-y-2 text-xs">
      <Link
        to="/mentions-legales"
        target="_blank"
        rel="noreferrer"
        className="focus-ring text-brand underline"
      >
        {t("footer.legalNotice")}
      </Link>
      <Link to="/cgu" target="_blank" rel="noreferrer" className="focus-ring text-brand underline">
        {t("footer.terms")}
      </Link>
      <Link
        to="/confidentialite"
        target="_blank"
        rel="noreferrer"
        className="focus-ring text-brand underline"
      >
        {t("footer.dataProtection")}
      </Link>
      <PrivacyControls />
    </nav>
  );
}
